import { Pipe, PipeTransform } from '@angular/core';
import moment from 'moment-timezone';

moment.tz.setDefault('UTC');

/**
 * Moment timezone pipe. angular-moment-timezone didn't quite fit the bill.
 */
@Pipe({
    name: 'timezone',
    standalone: false
})
export class MomentTimezonePipe implements PipeTransform {
    transform(value: moment.MomentInput, tz: string): any {
        if (!value) return value;
        return moment(value).tz(tz);
    }
}
